import { createContext, useContext } from "react";
import type { DashboardData } from "../components/dashboard/types";

const DashboardDataContext = createContext<DashboardData | null>(null);

export function DashboardDataProvider({ value, children }: { value: DashboardData; children: React.ReactNode }) {
  return <DashboardDataContext.Provider value={value}>{children}</DashboardDataContext.Provider>;
}

export function useDashboardData(): DashboardData {
  const ctx = useContext(DashboardDataContext);
  if (!ctx) throw new Error("useDashboardData must be used within DashboardDataProvider");
  return ctx;
}
